import { flow } from "fp-ts/lib/function";

import { TagsValidation } from "../models";

import { validateTagDupesAndLimit } from "./validateTagDupesAndLimit";
import { validateTagLengthAndPattern } from "./validateTagLengthAndPattern";

export const validateTagInputValue = (
    inputElement: HTMLInputElement,
    tagName: string,
    tags: readonly string[],
): TagsValidation => {
    return flow(
        validateTagLengthAndPattern(inputElement),
        validateTagDupesAndLimit(tagName, tags),
    )(TagsValidation.Valid);
};
